const splitWordsRegexp = /[A-Z][^A-Z_-\s]*|[^A-Z_-\s]+/g;
const splitWords = (s) => s.match(splitWordsRegexp) || [];
const capitalize = (s) => s.slice(0, 1).toUpperCase() + s.slice(1);
const uncapitalize = (s) => s.slice(0, 1).toLowerCase() + s.slice(1);
const toCamel = (s, u) => {
	if (!s) {
		return "";
	}
	const tokens = splitWords(s).map((s) => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase());
	if (!tokens.length) {
		return "";
	}
	if (u) {
		const first = tokens.shift();
		return capitalize(first) + tokens.join("");
	}
	return tokens.join("");
};
const toTitle = (s) => {
	if (!s) {
		return "";
	}
	const tokens = splitWords(s);
	if (!tokens.length) {
		return "";
	}
	const first = capitalize(tokens.shift());
	if (!tokens.length) {
		return first;
	}
	return first + " " + tokens.join(" ");
};
const dash = (s) => splitWords(s).join("-").toLowerCase();
/**
* converts_a_string_to_snake_case.
*/
const snake = (s) => splitWords(s).join("_").toLowerCase();
/**
* converts-a-string-to-kebab-case.
*/
const kebab = dash;
/**
* ConvertsAStringToPascalCase
*/
const pascal = (s) => toCamel(s, true);
/**
* convertsAStringToCamelCase.
*/
const camel = (s) => toCamel(s);
/**
* CONVERTS_A_STRING_TO_MACRO_CASE.
*/
const macro = (s) => splitWords(s).join("_").toUpperCase();
/**
* Converts a string to title case.
*/
const title = (s) => toTitle(s);

export { camel, capitalize, dash, kebab, macro, pascal, snake, splitWords, title, uncapitalize };
//# sourceMappingURL=cases.js.map
